import {SET_EDIT_POPUP, SET_NEW_POPUP, CLOSE_POPUP, CREATE_NEW_DRAFT_CATEGORY} from '../constants/popup-constants'

export function setEditPopup(id){
    return {
        type: SET_EDIT_POPUP,
        id
    }
}

export function setNewPopup() {
    return{
        type: SET_NEW_POPUP
    }
}

export function closePopup() {
    return {
        type: CLOSE_POPUP
    }
}


// WEBPACK FOOTER //
// ./src/_app/drafts/actions/popup_actions.js